import { render, staticRenderFns } from "./ButtonControlHeader.vue?vue&type=template&id=2a234897"
import script from "./ButtonControlHeader.vue?vue&type=script&lang=js"
export * from "./ButtonControlHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports